<template>
  <div class="stripe-bind-div">
    <div id="payment-element"></div>
  </div>
</template>

<script>
import { API } from '@/net/http';
let Stripe = null;
import jsLoader from '../../utils/jsLoader';
export default {
  name: 'StripeBindCard',
  data() {
    return {
      loading: true,
      orderNum: this.$route.params.orderNumber,
      paymentMethod: '',
    };
  },
  mounted() {
    this.initJs();
    this._stripe = null;
    this._card = null;
    this._elements = null;
  },
  methods: {
    initJs() {
      this.loading = true;
      this.$emit('change-loading', true);
      jsLoader('https://js.stripe.com/v3/', 'stripe')
        .then(() => {
          this.loading = false;
          this.$emit('change-loading', false);
          Stripe = window.Stripe;
          this.initClientSecret();
        })
        .catch(() => {
          this.$emit('change-loading', false);
          this.loading = false;
          this.$Message.error({
            content: 'load stripe error',
            duration: 10,
          });
        });
    },
    initClientSecret() {
      this.loading = true;
      this.$emit('change-loading', true);
      this.$post(API.stripeBindCard)
        .then(res => {
          if (res.success) {
            let { publicKey, clientSecret } = res.data;
            this._client_secret = clientSecret;
            this.bindDom(publicKey);
          } else {
            this.loading = false;
            this.$emit('change-loading', false);
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.$emit('change-loading', false);
          this.loading = false;
        });
    },
    bindDom(publicKey) {
      const stripe = Stripe(publicKey);
      const options = {
        mode: 'setup',
        currency: 'usd',
      };
      const elements = stripe.elements(options);
      this._elements = elements;

      // Create Element instances
      const paymentElement = elements.create('payment', {
        defaultValues: {
          billingDetails: {
            email: this.$store.state.app.userInfo.email,
          },
        },
      });

      // Mount the Elements to their corresponding DOM node
      paymentElement.mount('#payment-element');

      this._stripe = stripe;
      this.loading = false;
      this.$emit('change-loading', false);
    },
    async confirmPayment(isDefault) {
      if (this.loading) {
        return;
      }
      if (this._stripe) {
        try {
          this.loading = true;
          this.$emit('change-loading', true);
          const elements = this._elements;
          await elements.submit();

          const clientSecret = this._client_secret;
          const confirmSetup = await this._stripe.confirmSetup({
            elements,
            clientSecret,
            redirect: 'if_required',
            confirmParams: {
              // Return URL where the customer should be redirected after the SetupIntent is confirmed.
              return_url: window.location.origin + '/#/user/profile',
            },
          });

          //成功后向服务器保存payment_method
          this.payment_method = confirmSetup.setupIntent.payment_method;
          const body = {
            paymentMethod: this.payment_method,
            isDefault: isDefault,
          };
          if (this.orderNum) body.orderNum = this.orderNum;

          this.$post(API.savePaymentMethod, body).then(res => {
            if (!res.success) return;
            this.$emit('bind-success');
          });
        } finally {
          this.loading = false;
          this.$emit('change-loading', false);
        }
      }
    },

    /**
     * 原来使用card element收集卡信息时的提交方式
     * @param isDefault 是否保存为默认卡
     */
    bindCard(isDefault) {
      if (this.loading) {
        return;
      }
      if (this._stripe) {
        this.loading = true;
        this.$emit('change-loading', true);
        this._stripe
          .confirmCardSetup(this._client_secret, {
            payment_method: {
              card: this._card,
            },
          })
          .then(result => {
            this.loading = false;
            this.$emit('change-loading', false);
            if (result.error) {
              this.$Message.error({
                content: result.error.message,
                duration: 3,
              });
            } else {
              //成功后向服务器保存payment_method
              this.payment_method = result.setupIntent.payment_method;
              const body = {
                paymentMethod: this.payment_method,
                isDefault: isDefault,
              };
              if (this.orderNum) body.orderNum = this.orderNum;

              this.$post(API.savePaymentMethod, body).then(res => {
                if (!res.success) return;
                this.$emit('bind-success');
              });
            }
          })
          .catch(() => {
            this.loading = false;
            this.$emit('change-loading', false);
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.stripe-bind-div {
  margin-top: 20px;
}
</style>
